<ng-template #loading>
  <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" />
</ng-template>

<ng-container *ngIf="seatDetails$ | async as details; else loading">
  <div class="flex flex--row flex--center bold-type font-heading-3 pr-xsmall-b font-headline-small">
    <div class="flex-1 nordic-blue-900-text text-icon-primary seat-info">
      <span *ngIf="seatTitle$ | async as teaserTitle; else loading">{{ teaserTitle }}</span>
      <span class="block">
        {{ details.seatNumber }}
        <span *ngIf="details.exitRow" class="heather-700-text text-icon-primary">{{
          'ancillaries.seats.popover.exitLabel' | finLocalization
        }}</span>
      </span>
    </div>
  </div>

  <div *ngIf="cmsSeatDetails$ | async as cmsDetails; else loading">
    <article
      class="block font-body-1 pr-xsmall-b font-body-medium"
      [innerHTML]="cmsDetails.detailText | finSafe: 'html'"
    ></article>

    <cms-unstyled-teaser
      class="block font-body-1 pr-xsmall-b font-body-medium"
      *ngFor="let r of cmsDetails.related"
      [content$]="r | finToObservable"
    />

    <fin-content-image
      *ngIf="cmsDetails.picture"
      [imageData$]="cmsDetails.picture | finToObservable"
      [aspectRatio$]="'16x9' | finToObservable"
    />

    <ng-container *ngIf="details.exitRow && !hideButtons">
      <fcom-button
        class="confirm-seat-button"
        [text]="'ancillaries.seats.popover.confirmExitRow' | finLocalization"
        [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.RIGHT }"
        [mode]="ButtonMode.FILL"
        (clickBtn)="confirmSeatClick(details, $event)"
      />

      <button
        class="clear-seat-button fill underline nordic-blue-900-text text-icon-primary align-center font-body-1 mr-xsmall-t font-body-medium"
        *ngIf="details.seatSelectedForTraveler"
        (click)="confirmSeatClick(details, $event)"
      >
        {{ 'ancillaries.seats.popover.clear' | finLocalization }}
      </button>
    </ng-container>
  </div>

  <ng-container *ngIf="!details.exitRow && !hideButtons">
    <fcom-button
      class="confirm-seat-button"
      [text]="
        (details.seatSelectedForTraveler ? 'ancillaries.seats.popover.modify' : 'ancillaries.seats.popover.confirm')
          | finLocalization
      "
      [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.RIGHT }"
      [mode]="ButtonMode.FILL"
      (clickBtn)="selectSeat(details, $event)"
    />

    <button
      class="clear-seat-button fill underline nordic-blue-900-text text-icon-primary align-center font-body-1 mr-xsmall-t font-body-medium"
      *ngIf="details.seatSelectedForTraveler"
      (click)="clearSeat(details, $event)"
    >
      {{ 'ancillaries.seats.popover.clear' | finLocalization }}
    </button>
  </ng-container>
</ng-container>
